module.exports = __webpack_public_path__ + "img/ljwm_04.67951a87.png";